var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "grey-text text-left text-darken-2" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("file.messages.documentClassificationTypeQuestion")) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.allowCreate
        ? _c(
            "material-input",
            {
              staticClass: "form-group-material-no-label",
              attrs: { value: _vm.computedSelectedType },
            },
            [
              _c("radio-section", {
                attrs: { name: "selected-type", options: _vm.typeOptions },
                model: {
                  value: _vm.computedSelectedType,
                  callback: function ($$v) {
                    _vm.computedSelectedType = $$v
                  },
                  expression: "computedSelectedType",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.computedSelectedType
        ? _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _vm.isSelectedTypeUseExisting
                ? _c(
                    "b-col",
                    {
                      attrs: { id: "existing-classification-select-container" },
                    },
                    [
                      _vm.isSelectedTypeUseExisting
                        ? _c("document-classification-select", {
                            attrs: {
                              id: "existing-classification-select",
                              "select-dropdown-parent":
                                "#existing-classification-select-container",
                              classifications: _vm.classifications,
                              value: _vm.selectedClassificationValue,
                              "allow-create": false,
                              "loader-position": "right",
                            },
                            on: { change: _vm.handleClassificationChange },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _c(
                    "b-col",
                    [
                      _c("classification-select-container", {
                        attrs: {
                          id: "new-classification-select",
                          "parent-id": "new-classification-select-container",
                          "application-id": _vm.applicationId,
                          "client-username": _vm.clientUsername,
                          "persist-selection": "",
                          "loader-position": "right",
                          "allow-manage": false,
                        },
                        on: { created: _vm.handleClassificationChange },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }